import "@/styles/globals.css";
import "@/lib/i18n";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/app/App";
import { registerSW } from "virtual:pwa-register";
import { initViewportInset } from "@/lib/utils/viewportInset";

initViewportInset();

// GYM-895: register Workbox service worker (autoUpdate).
// The SW is generated by vite-plugin-pwa; /api is excluded from precache.
// JWT refresh still works because the SW only handles shell assets.
registerSW({ immediate: true });

// When a new deployment replaces old chunk hashes, lazy-import of a stale
// chunk throws "Failed to fetch dynamically imported module". Force a reload
// so the browser picks up the new build — once only per session to avoid loops.
window.addEventListener('vite:preloadError', () => {
  if (!sessionStorage.getItem('vite_reload_attempted')) {
    sessionStorage.setItem('vite_reload_attempted', '1');
    window.location.reload();
  }
});

const container = document.getElementById("root");
if (!container) throw new Error("#root container missing in index.html");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
